import React from 'react';
import { IMedia } from '../../../common/types';
import { StickerItem, Image, RemoveIconWrapper } from './styled';

import { useBrandKitState } from '../../../store';
import { CloseIcon } from '@unfold/icon';

interface IStickerProps {
  logo: IMedia;
}

export const Sticker: React.FC<IStickerProps> = ({ logo }) => {
  const [, actions] = useBrandKitState();

  const handleRemoveMedia = (): void => {
    actions.removeMedia(logo.uuid);
  };

  return (
    <StickerItem variant="outlined">
      <RemoveIconWrapper id="close-button" onClick={handleRemoveMedia}>
        <CloseIcon />
      </RemoveIconWrapper>
      <Image src={logo.value} />
    </StickerItem>
  );
};
